import PrivateNetworkClient from "helpers/privateNetwork";

/**
 * Analytics API.
 *
 * Every report below takes the same filter shape, which is what lets a single
 * FilterBar drive all of them. The token guard matches the existing services:
 * a request made before login would otherwise 401 on page load.
 */
const hasToken = () => localStorage.getItem("token") !== null;

const post = async (path, filters) => {
  if (!hasToken()) return null;
  const { data } = await PrivateNetworkClient.post(path, JSON.stringify(filters));
  return data;
};

const FilterOptions = async () => {
  if (!hasToken()) return null;
  const { data } = await PrivateNetworkClient.get("/analytics/filterOptions");
  return data;
};

const ManpowerTrend = (filters) => post("/analytics/manpowerTrend", filters);
const ContractorManpower = (filters) => post("/analytics/contractorManpower", filters);
const SiteComparison = (filters) => post("/analytics/siteComparison", filters);
const ArrivalPattern = (filters) => post("/analytics/arrivalPattern", filters);
const AttendanceSummary = (filters) => post("/analytics/attendanceSummary", filters);
const MonthlyAttendance = (filters) => post("/analytics/monthlyAttendance", filters);

const ManpowerForecast = async (horizonDays = 14) => {
  if (!hasToken()) return null;
  const { data } = await PrivateNetworkClient.get(
    `/analytics/forecast?horizonDays=${horizonDays}`
  );
  return data;
};

export {
  FilterOptions,
  ManpowerTrend,
  ContractorManpower,
  SiteComparison,
  ArrivalPattern,
  AttendanceSummary,
  MonthlyAttendance,
  ManpowerForecast,
};
